import React, { useLayoutEffect } from 'react';
import PoCalendar from './Components/PoCalendar';
import { Box } from '@mui/material';

function App() {
useLayoutEffect(() => {
     document.body.style.backgroundColor = "#fff6f6"
});
  return (
    <Box 
      className="App" 
      sx={{
        backgroundColor: '#fff6f6',
        minHeight: '100vh',
        width: '100%',
        margin: 0,
        padding: 0
      }}
    >
        <Box sx={{ 
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
        }}>
            <PoCalendar />
          </Box>
    </Box>
  );
}

export default App;
